module.exports = __webpack_public_path__ + "media/react/assets/Performance-5ef9500b2935230c87f61bc444d2830f.svg";